<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('myrequest.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('myrequest.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.details') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper mt-30">
        <v-flex class="inner_basic_wrap type2">
          <v-tabs
            class="my_app_tabs_data type2"
            hide-slider
            grow
          >
            <v-tab>{{ $t('myrequest.view.fields.request_data') }}</v-tab>
            <v-tab>{{ $t('myrequest.view.fields.invoice_receipt') }}</v-tab>
            <v-tab v-if="receiptStatusTypeCode === '4308'">{{ $t('myrequest.view.fields.comment') }}</v-tab>
            <v-tab>{{ $t('myrequest.view.fields.service_result') }}</v-tab>

            <v-tab-item>
              <v-layout class="mt-0">
                <ApplicationInformation
                  :receipt_no.sync = receipt_no
                  v-if="application_cnt > 0"
                />
                <RequestInformation
                  :receipt_no.sync = receipt_no
                  v-if="application_cnt === 0"
                />
              </v-layout>
              <h2 class="m_title solo mt-45">{{ $t('public.certifiedcopyservice.fields.service_type') }}</h2>
              <div class="pl-20 pr-20">
                <v-radio-group
                  v-model="typeCode"
                  class="view__radio"
                >
                  <template v-for="(code, i) in ($vuetify.rtl ? typeCodeArList:typeCodeEnList)">
                    <v-radio
                      :key="code.value"
                      :label="code.text"
                      :value="code.value"
                      style="height:30px;"
                      disabled
                      readonly
                    >
                    </v-radio>
                    <v-spacer class="hidden_lr10" :key="i" v-if="i==0"></v-spacer>
                  </template>
                </v-radio-group>
              </div>

              <h2 class="m_title solo mt-45" v-show="(typeCode !== '4802' && typeCode !== '4804' && typeCode !== '4805' && typeCode !== '4806')
                || (typeCode === '4804' && (indArLangType === 'Y' || indEnLangType === 'Y'))
                || (typeCode === '4805' && (indArLangType === 'Y' || indEnLangType === 'Y'))
                || (typeCode === '4806' && (indArLangType === 'Y' || indEnLangType === 'Y'))">{{ $t('public.certifiedcopyservice.fields.language_type') }}</h2>
              <div v-show="(typeCode !== '4802' && typeCode !== '4804' && typeCode !== '4805' && typeCode !== '4806')
                || (typeCode === '4804' && (indArLangType === 'Y' || indEnLangType === 'Y'))
                || (typeCode === '4805' && (indArLangType === 'Y' || indEnLangType === 'Y'))
                || (typeCode === '4806' && (indArLangType === 'Y' || indEnLangType === 'Y'))" class="input_checkbox_type_basic radio_dailog_type row ma-0 mt-20 pl-15 pr-15">
                <v-checkbox
                  :label="$t('common.common.arabic')"
                  v-model="indArLangType"
                  value="Y"
                  false-value="N"
                  hide-details
                  readonly
                  class="view__chkbox"
                ></v-checkbox>
                <v-spacer class="hidden_lr10"></v-spacer>
                <v-checkbox
                  :label="$t('common.common.english')"
                  v-model="indEnLangType"
                  value="Y"
                  false-value="N"
                  hide-details
                  readonly
                  class="view__chkbox"
                ></v-checkbox>
              </div>
            </v-tab-item>

            <v-tab-item>
              <payment
                :payments.sync="paymentList"
                :receipt_no="receipt_no"
                :payment_history_seq="payment_history_seq"
                :query="$route.query"
                paid="Y"
              >
              </payment>
            </v-tab-item>

            <v-tab-item v-if="receiptStatusTypeCode === '4308'">
              <div class="component_1">
                <v-row>
                  <v-col cols="12" class="ma-0">
                    <v-data-table
                      :headers="$getHeaderType1(headerTxt, header)"
                      :items="commentList"
                      hide-default-footer
                      disable-sort
                      class="new__type__table empty__td"
                    >
                    </v-data-table>
                  </v-col>
                </v-row>
              </div>
            </v-tab-item>

            <v-tab-item>
              <DeliverableViewer
                :items="deliverableFileList"
              />
            </v-tab-item>
          </v-tabs>

          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-spacer></v-spacer>
              <v-btn
                color="#a01c2a"
                dark
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnGoList()"
              >{{ $t('common.button.go_to_list') }}</v-btn>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>

    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import DeliverableViewer from '@/components/layout/DeliverableViewer'
import ApplicationInformation from '@/components/layout/ApplicationInformation'
import RequestInformation from '@/views/myrequest/RequestInformation'
import Payment from '@/components/layout/Payment'

export default {
  components :{
    ApplicationInformation,
    DeliverableViewer,
    Payment,
    RequestInformation
  },
  data () {
    return {
      receipt_no : this.$route.params.receipt_no,
      payment_history_seq: null,
      paymentList: [],

      deliverableFileList : [],
      typeCode : '',
      typeCodeArList : [],
      typeCodeEnList : [],
      commentList: [],
      langTypeCode: '',
      application_cnt: 0,
      receiptStatusTypeCode: '',
      indArLangType: '',
      indEnLangType: '',

      headerTxt : {
        prefix : 'myrequest.view.fields.',
        txt : [ 'date', 'comment' ]
      },

      header: [
        { text: 'Date', align: 'center', value: 'date', width: '150' },
        { text: 'Comment', align: 'center', value: 'comment' }
      ]
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnGetTypecode()
    this.fnGetContent()
    this.fnGetDeliverableFileList()
    this.fnGetPaymentList()
  },
  methods: {
    fnGetTypecode(){
      let options = {
        upper_code: '4800'
      }
      utils.fnGetCodeList(options).then(list => {
        this.typeCodeArList = list.ar
        this.typeCodeEnList = list.en
      })
    },
    fnGetContent(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.application_cnt = res.data.application_cnt
            this.typeCode = res.data.certified_type_code
            this.indArLangType = res.data.ind_ar_lang_type
            this.indEnLangType = res.data.ind_en_lang_type
            this.receiptStatusTypeCode = res.data.receipt_status_type_code

            let comment = {
              date: res.data.modified_date,
              comment: res.data.result_notes
            }

            this.commentList.push(comment)
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGoList() {
      let url = location.href
      let qryStr = url.split('?')[1]
      this.$router.push('/myrequest/list?' + qryStr)
    },

    fnGetDeliverableFileList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/reports',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.deliverableFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDeliverableFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetPaymentList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/payments',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = i + 1
            }
            this.paymentList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetPaymentList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

  },
}
</script>